import { PALETTE, SIZES, MQ_TABLET} from '../../../../constants';
import { MediaQueryStyleSheet } from "react-native-responsive";
import ResponsiveDimensionValues from '../../../../components/common/responsive-dimension-values';
import { withOrientationChange } from 'react-device-detect';

const WINDOW_WIDTH = ResponsiveDimensionValues.windowWidth;
const blue = '#13223b';
const borderColor = 'rgb(38,49,71)';
const inputBorderColor = 'grey';

export default MediaQueryStyleSheet.create({

  root: {
    flex: 1,
    paddingVertical: 10,
    paddingHorizontal: 10,
    backgroundColor: PALETTE.loginBg,
  },
  autoWidth: {
    width: 'auto'
  },
  floatNone: {
    float: 'none'
  },
  rightFloat: {
    float: 'right'
  },
  width5per: {
    width: '5%'
  },
  leftmargin5per: {
    marginLeft: '5%'
  },
  leftFloat: {
    float: 'left'
  },
  payeeType: {
    padding: 10
  },
  accordion__body: {
    backgroundColor: 'red !important'
  },
  noPaddingLeft: {
    paddingLeft: 0
  },
  paddignTop10: {
    paddingTop: 10
  },
  beneficiaryConfirModal: {
    fontSize: 13,
  },
  padding20: {
    padding: 20
  },
  popUpText: {
    fontSize: 8,
    color: "black"
  },
  radioButton: {
    width: 30,
    height: 30,
    borderColor: PALETTE.primaryRadioButtonBorder,
  },
  payeeActive: {
    backgroundColor: '#00A3E0'
  },
  paddingBottom10: {
    paddingBottom: 10
  },
  textInput: {
    height: 40,
    borderColor: inputBorderColor,
    borderWidth: 1,
    borderRadius:2,
    flex: 0.5,
    color: PALETTE.primaryText,
    padding: 10,
    marginVertical: 8,
    backgroundColor: blue,
  },
  textInputAccordian: {
    height: 40,
    borderColor: inputBorderColor,
    borderWidth: 1,
    borderRadius:2,
    color: PALETTE.primaryText,
    padding: 10,
    marginVertical: 8,
  },
  beneNameField: {
    backgroundColor: blue,
    paddingHorizontal: 20,
    paddingVertical: 10,
    marginTop: 15,
    // flex: 1,
  },
  radioLabel: {
    color: PALETTE.secondaryText,
    fontSize: 16,
    paddingLeft: 10
  },
  label: {
    color: PALETTE.secondaryText,
    fontWeight: 'bold',
    marginBottom: 10
  },
  partialMatchLabel: {
    color: '#010E28',
    fontWeight: 100
  },
  labelCheck: {
    color: PALETTE.secondaryText,
    fontWeight: 'bold',
    marginLeft: 15,
  },
  setBottom: {
    flex : 0,
    marginVertical: 10,
    backgroundColor: PALETTE.loginSecondary,
    right: 0,
    paddingHorizontal: 20
  },
  inlineButton: {
    paddingVertical: 19,
  },
  continueButton: {
    backgroundColor: PALETTE.loginSecondary,
    height: 40,
    flex : 0,
    bottom: 10,
    marginHorizontal: 20,
    marginTop: 20,
    paddingVertical:8,
  },
  disableButton: {
    backgroundColor: blue,
    height: 40,
    flex : 0,
    bottom: 10,
    marginHorizontal: 20,
    marginTop: 20,
    paddingVertical:8,
  },
  searchButton: {
    alignSelf: 'flex-end',
    marginVertical: 10
  },
  checkBoxWrapper:{
    flex:1,
    alignItems:'center',
    marginVertical: 10,
    flexDirection:'row',
  },
  beneNameFieldDestination: {
    backgroundColor: blue,
    padding:20
  },
  modalstyle:{
    flex:1
  },
  modalWrapper:{
    flex:1,
    flexDirection:'column',
    justifyContent:'center',
    paddingHorizontal:10,
    marginTop:-100
  },
  modalHeader :{
    flexDirection:'row',
    backgroundColor:blue,
    borderBottomWidth: 2,
    borderColor: borderColor,
    paddingVertical:10
  },
  modalHeading:{
    flex:0.9,
    alignSelf:'center',
    textAlign: 'center'
  },
  closeContainer:{
    flex:0.1,
    alignSelf:'center'
  },
  modalContent:{
    padding:15,
    backgroundColor:blue
  },
  modalRowLeft:{
    paddingBottom:35,
    flex:0.95
  },
  modalRowRight:{
    flex:0.05,
    alignSelf:'center',
    paddingBottom:15
 },
  countryBtn: {
   right: 5,
   position: 'absolute',
   top: 18,
   marginTop: 113,
   marginRight: 20,
   paddingHorizontal: 10
  },
  searchInline :{
    color:PALETTE.loginSecondary,
    paddingVertical:13
  },
  error:{
    height: 40,
    borderColor: PALETTE.errorColor,
    borderWidth: 1,
    borderRadius:2,
    flex: 0.5,
    color: PALETTE.primaryText,
    padding: 10,
    marginVertical: 8,
    backgroundColor: blue,
  },
  destActivityLoader:{
    flex:1,
   marginTop:50
  },
  PT15: {
    paddingTop: 15
  },
  PT20: {
    paddingTop: 20
  },
  PB20: {
    paddingBottom:20
  },
  MT4: {
    marginTop: 4
  },
  PT10: {
    paddingTop: 10
  },
  accountTypeAsterick: {
    paddingLeft: 3,
    color:PALETTE.primaryActive
    
  },
  noCountryRecord:{
    paddingTop: 10,
    paddingBottom: 15,
    paddingLeft: 10,
    display: "inline-block"
  },
  businessAccountTypePopover: {
    backgroundColor: 'white'
  },
  asteriskStyle:{
    color:PALETTE.primaryActive,
    verticalAlign:'super'
  },
  marginTop:{
    marginTop: 20
  }
});

export const activeSVGStyles = {
  color: PALETTE.primaryText,
};

export const inactiveSVGStyles = {
  color: 'rgba(255, 255, 255, 0.4)', // TODO palettise
};
